// Module
var code = `<sub-header header="'Letters'"></sub-header>
<div class="horizontal" ng-form="\$ctrl.filter">
  <div class="filters">
    <div class="labelled-field">
      <label>Customer</label>
      <select
        ng-model="\$ctrl.selectedCustomerId"
        ng-options="c.id as c.effectiveName for c in \$ctrl.allCustomers">
      </select>
    </div>
    <div class="labelled-field">
      <label>Letter</label>
      <select
        required
        ng-model="\$ctrl.selectedLetter"
        ng-options="type.id as type.name for type in \$ctrl.letters">
      </select>
    </div>
    <button type="button" class="btn btn-danger" ng-click="\$ctrl.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-success" ng-click="\$ctrl.displayPrint()">
      Display
    </button>
  </div>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/loan-letters/loan-letters.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;